import { qtiLoginConstants } from "../constants/qtiLoginConstants"

const initialState = {
  loading: false,
  success: false,
  error: null,
  data: null
}

export const qtiLoginState = (state = initialState, action) => {
  switch (action.type) {
    case qtiLoginConstants.QTI_LOGIN_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
        data: null
      }
    case qtiLoginConstants.QTI_LOGIN_SUCCESS:
      return {
        ...state,
        success: true,
        loading: false,
        error: null,
        data: action.payload
      }
    case qtiLoginConstants.QTI_LOGIN_ERROR:
      return {
        ...state,
        success: false,
        loading: false,
        error: action.payload,
        data: null
      }
    default:
      return state
  }
}
